import { createDomainStore } from '../../../storage/create-domain-store';
import { DomainStoreType } from '../../../storage/types/domain-store';
import { defaultTemporaryLoyaltyDomainState } from './state';
export const temporaryLoyaltyDomainStore = createDomainStore({
    type: DomainStoreType.Memory,
    defaultState: defaultTemporaryLoyaltyDomainState
});
